import { render, staticRenderFns } from "./PromotionBm.vue?vue&type=template&id=0b7840ec&scoped=true"
import script from "./PromotionBm.vue?vue&type=script&lang=js"
export * from "./PromotionBm.vue?vue&type=script&lang=js"
import style0 from "./PromotionBm.vue?vue&type=style&index=0&id=0b7840ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7840ec",
  null
  
)

export default component.exports